/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as moment from 'moment';
import { PDFDocument } from 'pdf-lib';
/* Package JSON Import will be here */

/* Project Import will be here */
import TimeCardComponent from './timeCard.Component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class TimeCard extends Component {
    constructor(props) {
        super(props);
        var todayDate = new Date();
        var selectFromDate = new Date();
        var diff = selectFromDate.getDate() - selectFromDate.getDay() + (selectFromDate.getDay() === 0 ? -6 : 1);
        selectFromDate = new Date(selectFromDate.setDate(diff));
        this.state = {
            timeRecords: [],
            isIssueClicked: false,
            isDailyDetailsClicked: false,
            selectedToDate: todayDate,
            selectedFromDate: selectFromDate,
            defaultFromDate: selectFromDate,
            defaultToDate: todayDate,
            selectedWeekEndingDate: null,
            weekEndDate: null,
            selectedSyncDate: null,
            selectedNotes: {},
            isOpenPayRollNotes: false,
            isOpenActualNotes: false,
            isOpenExceptationalNotes: false,
            timeCardEmployeeSearchText: "",
            timeCardDeviceSearchText: "",
            timeCardProjectSearchText: "",
            timeCardTaskNameSearchText: "",
            timeCardPayCodeSearchText: "",
            timeCardTotalHoursSearchText: "",
            timeCardActualUnitSearchText: "",
            timeCardJobOverrideSearchText: "",
            timeCardWorkDoneAtJobSiteSearchText: "",
            timeCardUnionOverrideSearchText: "",
            timeCardExpectationUnitsSearchText: "",
            timeCardStartTimeSearchText: "",
            timeCardEndTimeSearchText: "",
            timeCardDaySearchText: "",
            timeCardSyncedDateTimeSearchText: "",
            timeCardWeekEndingDateSearchText: "",
            timeCardFieldStatusSearchText: "",
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            isAttachmentModelVisible: false,
            selectedAttachment: "",
            isShowActualModalLoading: false,
            totalRecordId: [],
            isShowAttestationModal: false,
            timeCardLunchStartTimeSearchText: "",
            timeCardLunchEndTimeSearchText: "",
            attestationStatus: [
                { id: 0, text: Constants.ATTESTATION_STATUS_APPROVED, value: Constants.ATTESTATION_STATUS_APPROVED_SEARCH_TEXT },
                { id: 1, text: Constants.ATTESTATION_STATUS_REJECTED, value: Constants.ATTESTATION_STATUS_REJECTED_SEARCH_TEXT },
                { id: 2, text: Constants.ATTESTATION_STATUS_OVERRIDE, value: Constants.ATTESTATION_STATUS_OVERRIDE_SEARCH_TEXT },
                { id: 3, text: Constants.ATTESTATION_NONE, value: Constants.ATTESTATION_NONE },
            ],
            selectedAttestationStatus: [],
            selectedAttestationPDF: {
                attachmentContent: "",
                attachmentName: ""
            },
            isCheckedArchive: false,
            lastArchiveDate: null,
            minimumDate: null,
            maximumDate: null,
            selectedLastArchiveDate: "",
            archiveEndDate: "",
            isShowArchiveModal: false,
            isInputEnabled: false
        };

        this.initialTimeCardFetch = false;
        this.timeCardTimeOut = null;
        this.getTimeCardAbortController = new AbortController();
    }

    componentWillMount() {
        this.initialTimeCardFetch = true;
        this.getTimeCardDataDelay(null, null);
    }

    componentWillUnmount() {
        clearTimeout(this.timeCardTimeOut);
        if (this.getTimeCardAbortController) this.getTimeCardAbortController.abort();
    }

    getTimeCardData(dateSelectedFrom = null, dateSeletedTo = null) {
        if (this.getTimeCardAbortController) {
            this.getTimeCardAbortController.abort();
        }
        this.getTimeCardAbortController = new AbortController();
        clearTimeout(this.timeCardTimeOut);
        this.timeCardTimeOut = setTimeout(() => this.getTimeCardDataDelay(dateSelectedFrom, dateSeletedTo), 1000);
    }

    getTimeCardDataDelay(dateSelectedFrom = null, dateSeletedTo = null) {
        let { pagination,
            timeCardEmployeeSearchText,
            timeCardDeviceSearchText,
            timeCardProjectSearchText,
            timeCardTaskNameSearchText,
            timeCardPayCodeSearchText,
            timeCardTotalHoursSearchText,
            timeCardActualUnitSearchText,
            timeCardJobOverrideSearchText,
            timeCardWorkDoneAtJobSiteSearchText,
            timeCardUnionOverrideSearchText,
            timeCardExpectationUnitsSearchText,
            timeCardStartTimeSearchText,
            timeCardEndTimeSearchText,
            timeCardDaySearchText, timeCardWeekEndingDateSearchText, timeCardSyncDateSearchText, timeCardFieldStatusSearchText, totalRecordId,
            timeCardLunchStartTimeSearchText,
            timeCardLunchEndTimeSearchText,
            selectedAttestationStatus,
            minimumDate,
            lastArchiveDate
        } = this.state;

        var dateRangeFrom = dateSelectedFrom == null ? new Date(this.state.defaultFromDate) : new Date(dateSelectedFrom);
        //var fromDate = moment(new Date(dateRangeFrom).toDateString()).format("YYYY-MM-DD");
        var dateRangeTo = dateSeletedTo == null ? new Date(this.state.defaultToDate.getTime() + 1 * 24 * 60 * 60 * 1000) : new Date(dateSeletedTo.getTime() + 1 * 24 * 60 * 60 * 1000);
        //var toDate = moment(new Date(dateRangeTo).toDateString()).format("YYYY-MM-DD");

        //var datePicked = dateSelect == null ? new Date(selectedDate) : new Date(dateSelect);
        var startTime = new Date(dateRangeFrom.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        //var tomorrow = dateSelect == null ? new Date(selectedDate) : new Date(dateSelect);
        var endTime = dateRangeTo.setDate(dateRangeTo.getDate());
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format('DD-MM-YYYY');
        var dateSelected = moment(dateEndTime).format('DD-MM-YYYY');
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${dateSelected} ${selectTimeZone}`;


        totalRecordId = [];
        let searchArray = [];
        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });
        if (timeCardEmployeeSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_EMPLOYEE_SEARCH,
                Value: timeCardEmployeeSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardDeviceSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_DEVICE_SEARCH,
                Value: timeCardDeviceSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardProjectSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_PROJECT_SEARCH,
                Value: timeCardProjectSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardTaskNameSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_TASKNAME_SEARCH,
                Value: timeCardTaskNameSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardPayCodeSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_PAYCODE_SEARCH,
                Value: timeCardPayCodeSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardTotalHoursSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_TOTAL_HOURS_SEARCH,
                Value: timeCardTotalHoursSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardActualUnitSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_ACTUAL_UNITS_SEARCH,
                Value: timeCardActualUnitSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardJobOverrideSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_JOB_OVERRIDE_SEARCH,
                Value: timeCardJobOverrideSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardWorkDoneAtJobSiteSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_WORK_DONE_AT_JOB_SITE_SEARCH,
                Value: timeCardWorkDoneAtJobSiteSearchText
            };
            searchArray.push(searchObj);
        }
        if (timeCardUnionOverrideSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_UNION_OVERRIDE_SEARCH,
                Value: timeCardUnionOverrideSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardExpectationUnitsSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_EXPECTATION_UNITS_SEARCH,
                Value: timeCardExpectationUnitsSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardStartTimeSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_START_TIME_SEARCH,
                Value: timeCardStartTimeSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardEndTimeSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_END_TIME_SEARCH,
                Value: timeCardEndTimeSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardLunchStartTimeSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_LUNCH_START_TIME_SEARCH,
                Value: timeCardLunchStartTimeSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardLunchEndTimeSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_LUNCH_END_TIME_SEARCH,
                Value: timeCardLunchEndTimeSearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardDaySearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_DAY_SEARCH,
                Value: timeCardDaySearchText
            };
            searchArray.push(searchObj);
        };
        if (timeCardWeekEndingDateSearchText) {
            let searchObj = {
                FieldName: Constants.WEEK_ENDING_DATE_SEARCH,
                Value: timeCardWeekEndingDateSearchText
            };
            searchArray.push(searchObj);
        };
        if (selectedAttestationStatus.length > 0) {
            let searchObj = {
                FieldName: Constants.ATTESTATION_STATUS_SEARCH,
                Value: selectedAttestationStatus.map(a => a.text).join(' ')
            };
            searchArray.push(searchObj);
        }
        if (timeCardSyncDateSearchText) {
            var syncTime = new Date(timeCardSyncDateSearchText.setHours(0, 0, 0));
            var syncDate = new Date(syncTime.setMinutes(syncTime.getTimezoneOffset()));
            var selectDate = moment(syncDate).format('DD-MM-YYYY');
            var timeZone = syncDate.toString();
            var selectTimeZone = timeZone.slice(16, 24);
            var timecardSyncedDate = `${selectDate} ${selectTimeZone}`;
            let searchObj = {
                FieldName: Constants.TIMECARD_SYNC_DATE_SEARCH,
                Value: timecardSyncedDate
            };
            searchArray.push(searchObj);
        };
        if (timeCardFieldStatusSearchText) {
            let searchObj = {
                FieldName: Constants.TIMECARD_SEARCH_CODE_SEARCH,
                Value: timeCardFieldStatusSearchText
            };
            searchArray.push(searchObj);
        };

        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TME_CRD_DT_M}?fromDate=${fromDate}&&toDate=${toDate}&&isCheckedArchive=${this.state.isCheckedArchive}`;
        Api.Post(url, requestData, this, this.getTimeCardAbortController?.signal).then(responseData => {
            if (responseData.success) {
                if (!this.state.selectedFromDate && !this.state.selectedToDate && pagination.activePage === 1) {
                    MessageBox(Constants.CURRENT_WEEK_DETAILS, Constants.SUCCESS);
                }
                pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                var timeRecordData = responseData.data.timecardList;
                totalRecordId = (pagination.totalCount > 0 && pagination.activePage > 1) ? totalRecordId : [];
                timeRecordData.forEach((a) => {
                    a.weekEndingDate = moment(new Date(`${a.weekEndingDate}`)).format("MM/DD/YY");
                    a['isTimeRecordIdExist'] = false;
                    if (totalRecordId.length > 0 && totalRecordId.includes(`${a.timeRecordID}${a.deviceID}`)) {
                        a.workUnits = '';
                        a.expectationUnits = '';
                        a['isTimeRecordIdExist'] = true;
                    }
                    else {
                        totalRecordId.push(`${a.timeRecordID}${a.deviceID}`);
                    }
                })
                if (this.initialTimeCardFetch && responseData.data.lastArchiveDate) {
                    let archiveDate = new Date(responseData.data.lastArchiveDate);
                    archiveDate = new Date(archiveDate.setDate(archiveDate.getDate() + 1));
                    minimumDate = archiveDate;
                    lastArchiveDate = archiveDate;
                }
                this.setState({
                    timeRecords: timeRecordData,
                    pagination,
                    totalRecordId,
                    lastArchiveDate,
                    isInputEnabled: true,
                    ...(this.initialTimeCardFetch && { minimumDate })
                });
                this.initialTimeCardFetch = false;
            }
        });
    }

    getTimeCardIssue() {
        this.setState({
            isIssueClicked: true
        });
    }
    getTimeCardDailyDetails() {
        this.setState({
            isDailyDetailsClicked: true
        });
    }

    onTimecardEmployeeSearch = event => {
        this.setState({ timeCardEmployeeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardDeviceSearch = event => {
        this.setState({ timeCardDeviceSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardProjectSearch = event => {
        this.setState({ timeCardProjectSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardTaskNameSearch = event => {
        this.setState({ timeCardTaskNameSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardPayCodeSearch = event => {
        this.setState({ timeCardPayCodeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardTotalHoursSearch = event => {
        this.setState({ timeCardTotalHoursSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardActualUnitsSearch = event => {
        this.setState({ timeCardActualUnitSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardStartTimeSearch = event => {
        this.setState({ timeCardStartTimeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardEndTimeSearch = event => {
        this.setState({ timeCardEndTimeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardLunchStartTimeSearch = event => {
        this.setState({ timeCardLunchStartTimeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardLunchEndTimeSearch = event => {
        this.setState({ timeCardLunchEndTimeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardDaysSearch = event => {
        this.setState({ timeCardDaySearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardJobOverrideSearch = event => {
        this.setState({ timeCardJobOverrideSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardWorkDoneAtJobSiteSearch = event => {
        this.setState({ timeCardWorkDoneAtJobSiteSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardUnionOverrideSearch = event => {
        this.setState({ timeCardUnionOverrideSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardExpectationunitsSearch = event => {
        this.setState({ timeCardExpectationUnitsSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onWeekEndingDateSearch(date) {
        this.setState({ timeCardWeekEndingDateSearchText: date, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onTimecardStatusCodeSearch = event => {
        this.setState({ timeCardFieldStatusSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        })
    }

    handleToDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            if (date === null) {
                MessageBox(Constants.SELCET_TO_DATE, Constants.ERROR);
            }
            else if (date < this.state.selectedFromDate && moment(new Date(date).toDateString()).format("YYYY-MM-DD") !== moment(new Date(this.state.selectedFromDate).toDateString()).format("YYYY-MM-DD")) {
                MessageBox(Constants.DATE_RAGE_VALIDATION, Constants.ERROR);
            } else {
                this.setState({
                    selectedToDate: date,
                    pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
                }, () => {
                    this.getTimeCardData(this.state.selectedFromDate, date);
                });
            }
        }
        else {
            this.setState({
                timeRecords: []
            });
        }
    }

    handleFromDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            if (date === null) {
                MessageBox(Constants.SELCET_FROM_DATE, Constants.ERROR);
            }
            else if (date > this.state.selectedToDate) {
                MessageBox(Constants.DATE_RAGE_VALIDATION, Constants.ERROR);
            } else {
                this.setState({
                    selectedFromDate: date,
                    pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
                }, () => {
                    this.getTimeCardData(date, this.state.selectedToDate);
                });
            }
        }
        else {
            this.setState({
                timeRecords: []
            });
        }
    }

    handleWeekEndingDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date)) && date != null) {
            this.setState({
                selectedWeekEndingDate: date,
                weekEndDate: moment(date, "MM/DD/YYYY").format("MM/DD/YYYY"),
                timeCardWeekEndingDateSearchText: moment(date, "MM/DD/YYYY").format("MM/DD/YYYY"),
                pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
            }, () => {
                this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
            });
        }
        else {
            this.setState({
                selectedWeekEndingDate: null,
                timeCardWeekEndingDateSearchText: "",
                timeRecords: []
            }, () => {
                this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
            });
        }
    }

    handleSyncDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date)) && date != null) {
            this.setState({
                selectedSyncDate: date,
                timeCardSyncDateSearchText: date,//moment(date, "DD-MM-YYYY").format("DD-MM-YYYY"),
                pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 }
            }, () => {
                this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
            });
        }
        else {
            this.setState({
                selectedSyncDate: null,
                //  weekEndDate: null,
                timeCardSyncDateSearchText: "",
                timeRecords: []
            }, () => {
                this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
            });
        }
    }

    closeIssueNotes(issue) {
        this.setState({
            isIssueClicked: false
        })
    }
    closeDailyDetailsNotes(daily) {
        this.setState({
            isDailyDetailsClicked: false
        })
    }

    openNotes = notes => {
        let { timeRecords } = this.state;
        let selectedNotes;
        if (notes.timeCardId) {
            selectedNotes = timeRecords.find(a => a.timeRecordID === notes.timeCardId && a.deviceID === notes.deviceId);
        }
        if (notes.modalOpenPayRollNote) {
            this.setState({ isOpenPayRollNotes: notes.modalOpenPayRollNote, selectedNotes: selectedNotes });
        }
        else if (notes.modalOpenActualNote) {
            let isAttachmentAdded = selectedNotes && ((selectedNotes.attachments && selectedNotes.attachments.length === 0) || !selectedNotes.attachments);
            if (isAttachmentAdded) {
                let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATMT_BY_TMECRD_M}?timeRecordId=${notes.timeCardId}&&deviceId=${notes.deviceId}&&isCheckedArchive=${this.state.isCheckedArchive}`;
                Api.Get(url, this).then(response => {
                    if (response.success) {
                        selectedNotes.attachments = response.data;
                        this.setState({ isShowActualModalLoading: false, selectedNotes: selectedNotes, timeRecords });
                    }
                    else {
                        this.setState({ isShowActualModalLoading: false });
                    }
                });
                this.setState({ isShowActualModalLoading: true, isOpenActualNotes: notes.modalOpenActualNote, selectedNotes: selectedNotes });
            }
            else {
                this.setState({ isOpenActualNotes: notes.modalOpenActualNote, selectedNotes: selectedNotes });
            }
        }
        else if (notes.modalOpenExceptationalNote) {
            this.setState({ isOpenExceptationalNotes: notes.modalOpenExceptationalNote, selectedNotes: selectedNotes });
        }
        else {
            this.setState({ isOpenPayRollNotes: false, isOpenActualNotes: false, isOpenExceptationalNotes: false, selectedNotes: selectedNotes, isShowActualModalLoading: false });
        }
    }

    openAttachmentViewer(attachment) {
        this.setState({
            isAttachmentModelVisible: true,
            selectedAttachment: attachment
        });
    }

    closeAttachmentViewer() {
        this.setState({
            isAttachmentModelVisible: false,
            selectedAttachment: ""
        });
    }

    paginationChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
        });
    }

    onClickPrint() {
        var printTemplate = this.getAttachmentTemplate();
        var divElement = document.createElement('html');
        divElement.innerHTML = printTemplate;
        var attachmentPrint = window.open('', '', 'left=0,top=0,width=850,height=700,toolbar=0,scrollbars=2,status=0');
        attachmentPrint.document.write(divElement.innerHTML);
        attachmentPrint.document.close();
        attachmentPrint.print()
    }

    getAttachmentTemplate() {
        let { selectedNotes } = this.state;
        let attachmentList = [];
        selectedNotes.attachments.forEach(data => {
            attachmentList = attachmentList.concat(`
            <TR>
                <TD><img alt=${data.attachmentName} src=${Constants.DATA_BASE64 + data.attachmentContent} height="350" width="550"/></TD>
            </TR>  
            `);
        });
        let printableSheet = ` 
        <body>            
            <Table style='font-size:11px;font: 11px Trebuchet MS, Verdana, Arial, Helvetica, sans-serif;' width='650'  border='0' cellpadding='0' cellspacing='0' align='center'>
                <TBODY>              
                ${attachmentList.join(" ")}     
                </TBODY>
            </Table>
        </body>`;
        return printableSheet;
    }

    async addTitle(base64Pdf, attachmentTitle) {
        const pdfDoc = await PDFDocument.load(base64Pdf);
        pdfDoc.setTitle(attachmentTitle);
        const pdfBytes = await pdfDoc.save();
        const base64PdfWithNewTitle = btoa(String.fromCharCode.apply(null, pdfBytes));
        return `${base64PdfWithNewTitle}`;
    }

    removeUnsupportedBase64Chars(base64String) {
        const base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        const regex = new RegExp(`[^${base64Chars.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}]`, 'g');
        const filteredString = base64String.replace(regex, '');
        return filteredString;
    }

    fixBase64Padding(base64String) {
        let cleanedString = this.removeUnsupportedBase64Chars(base64String);
        const paddingLength = (4 - (cleanedString.length % 4)) % 4;
        cleanedString += '='.repeat(paddingLength);
        return cleanedString;
    }

    async onOpenOrCloseAttestationModal(isOpen = false, timeRecordId = 0, deviceID = 0) {
        if (timeRecordId && deviceID && isOpen) {
            const { timeRecords } = this.state;
            const selectedTimeRecord = timeRecords.find(t => t.timeRecordID === timeRecordId && t.deviceID === deviceID);
            let attachmentContent = selectedTimeRecord?.attachmentContent ?? "";
            const attachmentName = selectedTimeRecord?.attachmentURI ?? "";

            if (!attachmentContent) {
                const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.CR_ATTST_PDF}?isFromUser=${true}&timeRecordId=${timeRecordId}&deviceId=${deviceID}`;
                const response = await Api.Get(url);
                if (response?.data?.attachmentContent?.length > 0) {
                    attachmentContent = response.data.attachmentContent;
                    selectedTimeRecord.attachmentContent = attachmentContent;
                }
            }

            const attestationAttachmentBase64 = this.fixBase64Padding(attachmentContent);
            let attestationBase64 = attachmentContent;
            try {
                attestationBase64 = await this.addTitle(attestationAttachmentBase64, attachmentName);
            } catch (error) {
                attestationBase64 = attachmentContent;
            }

            const selectedAttestationPDF = {
                attachmentContent: attestationBase64,
                attachmentName
            };
            this.setState({ isShowAttestationModal: true, selectedAttestationPDF });
        } else {
            this.setState({ isShowAttestationModal: false, selectedAttestationPDF: { attachmentContent: "", attachmentName: "" } });
        }
    }

    onChangeAttestation(value) {
        this.setState({ selectedAttestationStatus: value });
    }

    searchAttesation() {
        this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
    }

    handleArchiveCheckboxChange(isChecked) {
        let { lastArchiveDate, maximumDate, minimumDate } = this.state;
        var selectFromDate = new Date();
        var selectToDate = new Date();
        var diff = selectFromDate.getDate() - selectFromDate.getDay() + (selectFromDate.getDay() === 0 ? -6 : 1);
        selectFromDate = new Date(selectFromDate.setDate(diff));
        let result = new Date(lastArchiveDate);
        let archiveDate = new Date(result.setDate(result.getDate() - 1));
        minimumDate = lastArchiveDate;
        maximumDate = null;
        if (isChecked) {
            let tempArchiveDate = new Date(archiveDate);
            let mondayOfWeek = tempArchiveDate.getDate() - tempArchiveDate.getDay() + (tempArchiveDate.getDay() === 0 ? -6 : 1);
            selectToDate = archiveDate;
            selectFromDate = new Date(tempArchiveDate.setDate(mondayOfWeek));
            maximumDate = archiveDate;
            minimumDate = null;
        }
        this.setState({ isCheckedArchive: isChecked, selectedToDate: selectToDate, selectedFromDate: selectFromDate, minimumDate, maximumDate, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } });
        this.getTimeCardData(selectFromDate, selectToDate);
    }

    handleDateChange(SelectedDate) {
        if ((new Date(SelectedDate) !== "Invalid Date") && !isNaN(new Date(SelectedDate))) {
            var dateString = SelectedDate.toLocaleDateString("en-US");
            var splitDate = dateString.split(" ")[0];
            let archiveDate = moment(splitDate).format("MM/DD/YYYY");
            this.setState({
                selectedLastArchiveDate: archiveDate
            });
        }
    }

    submitArchieveProcess() {
        let { selectedLastArchiveDate } = this.state;
        let date = new Date(selectedLastArchiveDate);
        let startDate = new Date(date.setMinutes(date.getTimezoneOffset()));
        let timeZone = startDate.toString();
        let selectTimeZone = timeZone.slice(16, 24);
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SUBMIT_ARCHIEVE}?lastArchiveDate=${selectedLastArchiveDate}@${selectTimeZone}`;
        Api.Get(url, this).then(response => {
            if (response.success) {
                this.setState({ isShowArchiveModal: false }, () => {
                    this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
                });
            }
            else {
                this.getTimeCardData(this.state.selectedFromDate, this.state.selectedToDate);
                this.setState({ isShowArchiveModal: false });
            }
        });
    }

    showArchiveModal(isShowArchiveModal) {
        this.setState({ isShowArchiveModal });
    }


    render() {
        const { timeRecords, isIssueClicked, isDailyDetailsClicked, selectedToDate, selectedFromDate, selectedSyncDate, selectedNotes, isOpenPayRollNotes, isOpenActualNotes, isOpenExceptationalNotes, pagination, isAttachmentModelVisible, isShowActualModalLoading, selectedAttachment, selectedWeekEndingDate, weekEndDate, isShowAttestationModal, selectedAttestationPDF, attestationStatus, selectedAttestationStatus, isCheckedArchive, lastArchiveDate, minimumDate, maximumDate, selectedLastArchiveDate, archiveEndDate, isShowArchiveModal, isInputEnabled } = this.state;
        return (
            <Fragment>
                <TimeCardComponent
                    {...{
                        timeCard: {
                            timeRecords,
                            isIssueClicked,
                            isDailyDetailsClicked,
                            selectedToDate,
                            selectedFromDate,
                            selectedNotes,
                            isOpenPayRollNotes,
                            isOpenActualNotes,
                            isOpenExceptationalNotes,
                            pagination,
                            isAttachmentModelVisible,
                            selectedAttachment,
                            isShowActualModalLoading,
                            selectedWeekEndingDate,
                            weekEndDate,
                            selectedSyncDate,
                            isShowAttestationModal,
                            selectedAttestationPDF,
                            attestationStatus,
                            selectedAttestationStatus,
                            isCheckedArchive,
                            lastArchiveDate,
                            minimumDate,
                            maximumDate,
                            selectedLastArchiveDate,
                            archiveEndDate,
                            isShowArchiveModal,
                            isInputEnabled
                        }
                    }}
                    getTimeCardIssue={this.getTimeCardIssue.bind(this)}
                    getTimeCardDailyDetails={this.getTimeCardDailyDetails.bind(this)}
                    handleToDateChange={this.handleToDateChange.bind(this)}
                    handleFromDateChange={this.handleFromDateChange.bind(this)}
                    closeIssueNotes={this.closeIssueNotes.bind(this)}
                    closeDailyDetailsNotes={this.closeDailyDetailsNotes.bind(this)}
                    openNotes={this.openNotes.bind(this)}
                    paginationChange={this.paginationChange.bind(this)}
                    onTimecardEmployeeSearch={this.onTimecardEmployeeSearch.bind(this)}
                    onTimecardDeviceSearch={this.onTimecardDeviceSearch.bind(this)}
                    onTimecardProjectSearch={this.onTimecardProjectSearch.bind(this)}
                    onTimecardTaskNameSearch={this.onTimecardTaskNameSearch.bind(this)}
                    onTimecardPayCodeSearch={this.onTimecardPayCodeSearch.bind(this)}
                    onTimecardTotalHoursSearch={this.onTimecardTotalHoursSearch.bind(this)}
                    onTimecardActualUnitsSearch={this.onTimecardActualUnitsSearch.bind(this)}
                    onTimecardJobOverrideSearch={this.onTimecardJobOverrideSearch.bind(this)}
                    onTimecardUnionOverrideSearch={this.onTimecardUnionOverrideSearch.bind(this)}
                    onTimecardStartTimeSearch={this.onTimecardStartTimeSearch.bind(this)}
                    onTimecardEndTimeSearch={this.onTimecardEndTimeSearch.bind(this)}
                    onTimecardDaysSearch={this.onTimecardDaysSearch.bind(this)}
                    openAttachmentViewer={this.openAttachmentViewer.bind(this)}
                    closeAttachmentViewer={this.closeAttachmentViewer.bind(this)}
                    onTimecardWorkDoneAtJobSiteSearch={this.onTimecardWorkDoneAtJobSiteSearch.bind(this)}
                    onTimecardExpectationunitsSearch={this.onTimecardExpectationunitsSearch.bind(this)}
                    onWeekEndingDateSearch={this.onWeekEndingDateSearch.bind(this)}
                    onTimecardStatusCodeSearch={this.onTimecardStatusCodeSearch.bind(this)}
                    handleWeekEndingDateChange={this.handleWeekEndingDateChange.bind(this)}
                    handleSyncDateChange={this.handleSyncDateChange.bind(this)}
                    onClickPrint={this.onClickPrint.bind(this)}
                    onOpenOrCloseAttestationModal={this.onOpenOrCloseAttestationModal.bind(this)}
                    onTimecardLunchStartTimeSearch={this.onTimecardLunchStartTimeSearch.bind(this)}
                    onTimecardLunchEndTimeSearch={this.onTimecardLunchEndTimeSearch.bind(this)}
                    searchAttesation={this.searchAttesation.bind(this)}
                    onChangeAttestation={this.onChangeAttestation.bind(this)}
                    handleArchiveCheckboxChange={this.handleArchiveCheckboxChange.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    showArchiveModal={this.showArchiveModal.bind(this)}
                    submitArchieveProcess={this.submitArchieveProcess.bind(this)}
                    user={this.props.user}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

export default withRouter(connect(mapStateToProps)(TimeCard));

TimeCard.displayName = 'TimeCard';